import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';



import queryString from 'query-string';



import ReactHookFormTitleWithRadio from 'components/reactHookFormComponents/ReactHookFormTitleWithRadio';
import { ProcessEnvConfig } from 'config/ProcessEnvConfig';

import { OnlyContinueButton } from '../../../components/base/BottomStepComponent';
import ContentSections from '../../../components/base/ContentSections';
import ItemTypeSet from '../../../components/base/ItemTypeSet';
import {
  COUPON_MODES,
  COUPON_REDEMPTION_METHOD,
  COUPON_SET_MEDIUM,
  COUPON_SET_TYPES,
  COUPON_TYPES,
  DISPLAY_COUPON_SET_TYPES,
} from '../../../config/CustomEnums';
import { createAction } from '../../../utils';

import './CreateCouponStepOne.scss';

import ImportExistingCoupon from '../../../assets/images/coupon/importExistingCoupon.svg';
import SystemGenerated from '../../../assets/images/coupon/systemGenerated.svg';
import { tierTypeConfig } from 'config/TierTypeConfig';

export const COUPON_MEDIUM_CONFIG = {
  [COUPON_TYPES.NORMAL]: [
    {
      label: 'Online only',
      value: COUPON_SET_MEDIUM.ONLINE,
    },
    {
      label: 'Offline only',
      value: COUPON_SET_MEDIUM.OFFLINE,
    },
    {
      label: 'Online or offline',
      value: COUPON_SET_MEDIUM.ONLIEN_OR_OFFLINE,
    },
  ],
  [COUPON_TYPES.TICKET]: [
    {
      label: 'Offline only',
      value: COUPON_SET_MEDIUM.OFFLINE,
    },
  ],
};

export const OFFLINE_COUPON_TYPES_CONFIG = {
  [COUPON_TYPES.NORMAL]: [
    {
      id: COUPON_SET_TYPES.SYSTEM_GENERATED,
      title: DISPLAY_COUPON_SET_TYPES?.[COUPON_SET_TYPES.SYSTEM_GENERATED],
      image: SystemGenerated,
      description: 'Coupon generated by the system',
    },
    {
      id: COUPON_SET_TYPES.IMPORT_EXISTING_COUPON,
      title: 'External',
      image: ImportExistingCoupon,
      description: 'Import existing coupon to the system',
    },
  ],
  [COUPON_TYPES.TICKET]: [
    {
      id: COUPON_SET_TYPES.SYSTEM_GENERATED,
      title: DISPLAY_COUPON_SET_TYPES?.[COUPON_SET_TYPES.SYSTEM_GENERATED],
      image: SystemGenerated,
      description: 'Coupon generated by the system',
    },
  ],
};

export const ONLINE_COUPON_TYPES_CONFIG = [
  {
    id: COUPON_SET_TYPES.IMPORT_EXISTING_COUPON,
    title: 'External',
    image: ImportExistingCoupon,
    description: 'Import existing coupon to the system',
  },
];

export const OFFLINE_COUPON_REDEMPTION_METHOD_CONFIG = [
  {
    label: 'Merchant to scan coupon QR code',
    value: COUPON_REDEMPTION_METHOD.MERCHANT_APP_SCAN_COUPON_QR_CODE,
  },
  {
    label: 'Customer App to scan store QR code',
    value: COUPON_REDEMPTION_METHOD.USERS_SCAN_STORE_QR_CODE,
  },
  {
    label: 'Input store PIN code only',
    value: COUPON_REDEMPTION_METHOD.INPUT_STORE_STAFF_CODE,
  },
  {
    label: 'Sales system updated',
    value: COUPON_REDEMPTION_METHOD.POS_UPDATED_CODE,
  },
  // {
  //   label: 'Users copy the discount code',
  //   value: COUPON_REDEMPTION_METHOD.USERS_COPY_THE_DISCOUNT_CODE,
  // },
];

export const ONLINE_COUPON_REDEMPTION_METHOD_CONFIG = [
  {
    label: 'Sales system updated',
    value: COUPON_REDEMPTION_METHOD.POS_UPDATED_CODE,
  },
];

export const COUPON_MODE_OPTIONS = [
  {
    label: 'Common coupons',
    value: COUPON_MODES.COMMON,
  },
  {
    label: 'Store-specific coupons',
    value: COUPON_MODES.STORE_SPECIAL,
  },
];

const CreateCouponStepOne = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const params = useParams();
  const { id } = params;
  const { watch, setValue } = useFormContext();
  const typeField = 'type';
  const watchType = watch(typeField);
  const mediumTypeFieldName = 'mediumType';

  const watchMediumType = watch(mediumTypeFieldName);
  const offlineCouponSetTypeFieldName = 'offlineCouponSetType';
  const watchOfflineCouponSetType = watch(offlineCouponSetTypeFieldName);
  const watchOnlineCouponSetType = watch('onlineCouponSetType');
  const offlineRedemptionMethodFieldName = 'offlineRedemptionMethod';
  const watchOfflineRedemptionMethod = watch(offlineRedemptionMethodFieldName);
  const onlineRedemptionMethodFieldName = 'onlineRedemptionMethod';
  const watchOnlineRedemptionMethod = watch(onlineRedemptionMethodFieldName);
  const watchIsLinkedCustomer = watch('isLinkedCustomer');

  // const couponModeFieldName = 'mode';
  // const watchCouponModeFieldName = watch(couponModeFieldName);

  const [methodOptions, setMethodOptions] = React.useState(
    watchOfflineCouponSetType === COUPON_SET_TYPES.IMPORT_EXISTING_COUPON
      ? OFFLINE_COUPON_REDEMPTION_METHOD_CONFIG
      : OFFLINE_COUPON_REDEMPTION_METHOD_CONFIG.slice(0, 3),
  );

  const prefillValueBySearch = () => {
    const parsedSearch = queryString.parse(location.search);
    const { type, coupon_medium: couponMedium } = parsedSearch;
    const couponType = COUPON_TYPES?.[type];
    if (couponType === COUPON_TYPES.NORMAL) {
      setValue(typeField, couponType, { shouldDirty: true });
      COUPON_SET_MEDIUM?.[couponMedium] &&
        setValue(mediumTypeFieldName, COUPON_SET_MEDIUM?.[couponMedium], {
          shouldDirty: true,
        });
      return;
    }
    if (couponType === COUPON_TYPES.TICKET) {
      setValue(typeField, couponType, { shouldDirty: true });
      setValue(mediumTypeFieldName, COUPON_SET_MEDIUM.OFFLINE, {
        shouldDirty: true,
      });
      return;
    }
  };

  useEffect(() => {
    prefillValueBySearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    if (!watchMediumType) {
      setValue(mediumTypeFieldName, COUPON_SET_MEDIUM.OFFLINE, {
        shouldDirty: true,
      });
    }
    if (
      watchMediumType === COUPON_SET_MEDIUM.ONLINE ||
      watchMediumType === COUPON_SET_MEDIUM.ONLIEN_OR_OFFLINE
    ) {
      !watchOnlineCouponSetType &&
        setValue(
          'onlineCouponSetType',
          COUPON_SET_TYPES.IMPORT_EXISTING_COUPON,
          { shouldDirty: true },
        );
      !watchOnlineRedemptionMethod &&
        setValue(
          onlineRedemptionMethodFieldName,
          COUPON_REDEMPTION_METHOD.POS_UPDATED_CODE,
          { shouldDirty: true },
        );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchMediumType]);

  useEffect(() => {
    if (watchType === COUPON_TYPES.TICKET) {
      !watchOfflineCouponSetType &&
        setValue(
          offlineCouponSetTypeFieldName,
          COUPON_SET_TYPES.SYSTEM_GENERATED,
          { shouldDirty: true },
        );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchType]);

  useEffect(() => {
    setMethodOptions(
      watchOfflineCouponSetType === COUPON_SET_TYPES.IMPORT_EXISTING_COUPON
        ? OFFLINE_COUPON_REDEMPTION_METHOD_CONFIG
        : OFFLINE_COUPON_REDEMPTION_METHOD_CONFIG.slice(0, 3),
    );
  }, [watchOfflineCouponSetType]);

  const offlineCouponSection = () => {
    return (
      <>
        <div
          className={
            watchMediumType === COUPON_SET_MEDIUM.ONLIEN_OR_OFFLINE
              ? 'second-section'
              : 'create-section-label-bottom-space'
          }
        >
          <label className="step-one-title">Offline coupon code source</label>
          <div
            className={
              OFFLINE_COUPON_TYPES_CONFIG?.[watchType]?.length > 1
                ? 'step-type-area coupon-type-area'
                : 'step-type-area'
            }
          >
            {OFFLINE_COUPON_TYPES_CONFIG?.[watchType]?.map((typeItem) => (
              <ItemTypeSet
                moreThanThree={false}
                extraClassName="couponset-card"
                key={`${typeItem.id}-${typeItem.description}`}
                item={typeItem}
                selected={watchOfflineCouponSetType}
                onClick={(id) => {
                  setValue(offlineCouponSetTypeFieldName, id, {
                    shouldDirty: true,
                  });
                  if (id === COUPON_SET_TYPES.SYSTEM_GENERATED) {
                    setMethodOptions(
                      OFFLINE_COUPON_REDEMPTION_METHOD_CONFIG.slice(0, 3),
                    );
                    if (
                      watchOfflineRedemptionMethod ===
                      COUPON_REDEMPTION_METHOD.POS_UPDATED_CODE
                    ) {
                      setValue(offlineRedemptionMethodFieldName, null, {
                        shouldDirty: true,
                      });
                    }
                  } else {
                    setMethodOptions(OFFLINE_COUPON_REDEMPTION_METHOD_CONFIG);
                  }
                }}
                disabled={watchIsLinkedCustomer}
              />
            ))}
          </div>
        </div>
        <ReactHookFormTitleWithRadio
          title={'Offline redemption method'}
          valueFieldName={offlineRedemptionMethodFieldName}
          options={methodOptions}
          disabled={watchIsLinkedCustomer}
        />
      </>
    );
  };

  const onlineCouponSection = () => {
    return (
      <>
        <div className="create-section-label-bottom-space">
          <label className="step-one-title">Online coupon code source</label>
          <div
            className={
              ONLINE_COUPON_TYPES_CONFIG?.length > 1
                ? 'step-type-area coupon-type-area'
                : 'step-type-area'
            }
          >
            {ONLINE_COUPON_TYPES_CONFIG.map((typeItem) => (
              <ItemTypeSet
                moreThanThree={false}
                extraClassName="couponset-card"
                key={`${typeItem.id}-${typeItem.description}`}
                item={typeItem}
                selected={watchOnlineCouponSetType}
                onClick={(id) => {
                  setValue('onlineCouponSetType', id, { shouldDirty: true });
                }}
                disabled={watchIsLinkedCustomer}
              />
            ))}
          </div>
          <ReactHookFormTitleWithRadio
            title={'Online redemption method'}
            valueFieldName={onlineRedemptionMethodFieldName}
            options={ONLINE_COUPON_REDEMPTION_METHOD_CONFIG}
            disabled={watchIsLinkedCustomer}
          />
        </div>
      </>
    );
  };

  const sections = [
    <div>
      <ReactHookFormTitleWithRadio
        title={'Type'}
        valueFieldName={typeField}
        options={[
          {
            label: 'Coupons',
            value: COUPON_TYPES.NORMAL,
          },
          {
            label: 'Ticket',
            value: COUPON_TYPES.TICKET,
          },
        ]}
        defaultValue={COUPON_TYPES.NORMAL}
        extraActionOnChange={(value) => {
          if (value === COUPON_TYPES.TICKET) {
            setValue(mediumTypeFieldName, COUPON_SET_MEDIUM.OFFLINE, {
              shouldDirty: true,
            });
          }
        }}
      />
      <ReactHookFormTitleWithRadio
        title={'Coupon medium'}
        valueFieldName={mediumTypeFieldName}
        options={
          (ProcessEnvConfig.haveShopMall
            ? COUPON_MEDIUM_CONFIG?.[COUPON_TYPES.TICKET]
            : COUPON_MEDIUM_CONFIG?.[watchType] || []
          ).filter(option => {
            if (
              !tierTypeConfig.onlineStore
              && [
                COUPON_SET_MEDIUM.ONLINE,
                COUPON_SET_MEDIUM.ONLIEN_OR_OFFLINE,
              ].includes(option.value)) {
              return false;
            };
            return true;
          })
        }
        disabled={watchIsLinkedCustomer}
      />
      {[COUPON_SET_MEDIUM.ONLINE, COUPON_SET_MEDIUM.ONLIEN_OR_OFFLINE].includes(
        watchMediumType,
      ) && onlineCouponSection()}
      {watchMediumType === COUPON_SET_MEDIUM.ONLIEN_OR_OFFLINE && (
        <div className="create-section-split-line" />
      )}
      {[
        COUPON_SET_MEDIUM.OFFLINE,
        COUPON_SET_MEDIUM.ONLIEN_OR_OFFLINE,
      ].includes(watchMediumType) && offlineCouponSection()}
      {/* <ReactHookFormTitleWithRadio
        title={'Mode'}
        valueFieldName={couponModeFieldName}
        options={COUPON_MODE_OPTIONS}
        disabled={id}
        extraActionOnChange={(key) => {
          if (key === COUPON_MODES.STORE_SPECIAL) {
            setValue('shouldBeUsedInStores', true, {
              shouldDirty: true,
            });
          }
        }}
      /> */}
    </div>,
  ];

  const isContinueButtonDisabled = () => {
    if (
      watchMediumType === COUPON_SET_MEDIUM.ONLINE &&
      (!watchOnlineCouponSetType || !watchOnlineRedemptionMethod)
    ) {
      return true;
    }
    if (
      watchMediumType === COUPON_SET_MEDIUM.OFFLINE &&
      (!watchOfflineCouponSetType || !watchOfflineRedemptionMethod)
    ) {
      return true;
    }
    if (
      watchMediumType === COUPON_SET_MEDIUM.ONLIEN_OR_OFFLINE &&
      (!watchOfflineCouponSetType ||
        !watchOfflineRedemptionMethod ||
        !watchOnlineCouponSetType ||
        !watchOnlineRedemptionMethod)
    ) {
      return true;
    }
    // if (!watchCouponModeFieldName && !id) {
    //   return true;
    // }
    return false;
  };
  return (
    <>
      <div className="create-coupon-step-one-container">
        <ContentSections sections={sections} hidePreview={true} />
      </div>
      <OnlyContinueButton
        disabledContinue={isContinueButtonDisabled()}
        continueAction={() => {
          dispatch(
            createAction('createCoupon/stepChange')({
              step: 0,
              isValid: true,
            }),
          );
          // saveCouponToSessionStorage(getValues());
        }}
      />
    </>
  );
};
export default CreateCouponStepOne;